<template>
  <div>
    <div class="auto cell" style="margin-top: 15px;"></div> <!-- Dummy: for keep layout -->

    <!-- assets counter -->
    <div class="grid-x list-counter">
      <div v-if="assets.length > 0" class="flexbox-align-items">
        <span>{{assets.length}} asset<span v-if="assets.length > 1">s</span></span>
      </div>
      <div v-else class="large-12 no-result">
        <div class="grid-x">
          <div class="large-12 cell">
            <span>Ingen Asset emner, prøv med:</span>
            <ul>
              <li>Vise / skjule afsluttede</li>
            </ul>
          </div>
        </div>
        <div class="grid-x">
          <div class="large-12 no-result-img cell"></div>
        </div>
      </div>
    </div>

    <!-- assets sort -->
    <div v-if="assets.length > 0" class="grid-x list-sort non-sortable">
      <div class="large-1 cell"></div>
      <div class="large-11 cell">
        <div class="grid-x">
          <div class="large-1 cell"></div>
          <div class="large-3 cell non-sortable item flexbox no-margin">
            <span>Dato</span>
          </div>
          <div class="large-8 cel non-sortable item flexbox no-margin">
            <span>Beskrivelse</span>
          </div>
        </div>
      </div>
    </div>

    <!-- asset list -->
    <transition-group name="list" tag="div">
      <div v-for="asset in assets" :key="asset.id">
        <div class="grid-x entity-icon-row align-items">
          <div class="large-1 cell item flexbox-align-items">
            <input v-if="!asset.behandlingsDato" v-model="asset.checked" type="checkbox">
          </div>
          <div class="large-11 cell cursor">
            <div class="grid-x list-row entity-icon-row align-items">
              <div @click="openAssetDetails(asset)" class="large-1 cell">
                <icon class="larger-svg fill-primary-no-stroke" name="excel-icon"></icon>
              </div>
              <div @click="openAssetDetails(asset)" class="large-3 cell item flexbox-align-items">
                <span>{{ asset.aendringsDato | formatDate }}</span>
              </div>
              <div @click="openAssetDetails(asset)" class="large-8 cell item truncate-fade flexbox-align-items">
                <span>{{ asset.beskrivelse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

    <project-slider :sliderOpen="sliderOpen" :selectedAsset="selectedAsset" @toggleSlider="toggleSlider" :fullHeight="true"></project-slider>
  </div>
</template>

<script>
import projectSlider from '@/components/page/project/project-slider.vue'

export default {
    name: 'dashboard-assets-list',
    props: {
        value: Array,
        selectedTab: String
    },
    components: {
        'project-slider': projectSlider
    },
    data () {
        return {
            assets: this.value,
            sliderOpen: false,
            selectedAsset: null
        }
    },
    methods: {
        openAssetDetails (asset) {
            this.toggleSlider(true, asset)
        },
        toggleSlider (boolean, asset) {
            this.sliderOpen = boolean
            this.selectedAsset = asset
        }
    },
    watch: {
        value (assets) {
            this.assets = assets
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/dashboard/dashboard-assets-list.vue